export default "__VITE_ASSET__2a7fd038__"